import { ResultData, ValidateResult } from "@nt-portal/common-sdk";
import { Municipality, MunicipalityDataService } from "@nt-portal/doc-agent-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";
import { createDistrict } from "./client-district.service";

export interface MunicipalityOptions extends ControllerOptions<Municipality> {}

export const initMunicipality = (): Municipality => createMunicipality({});

export const createMunicipality = (item: Partial<Municipality>): Municipality => ({
    id: item.id ?? "",
    name: item.name ?? "",
    code: item.code ?? "",
    district: item.district ?? createDistrict({}),
    category: item.category ?? {
        name: "",
        code: "",
        createdBy: ""
    },
    createdBy: item.createdBy ?? ""
});

export class ClientMunicipalityService extends BaseClientService implements DataController<Municipality> {
    private _service: MunicipalityDataService;

    constructor() {
        super();
        this._service = new MunicipalityDataService({
            apiService: this.apiService,
            url: this.settings.docChatServer
        });
    }

    public async get(options: MunicipalityOptions): Promise<ResultData<Municipality>> {
        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);
    }

    public async getLookup(options: MunicipalityOptions): Promise<ResultData<Municipality>> {
        return await this._service.get(this.buildLookupFetchParams(options), this.token, options.filter);
    }

    public async getById(options: MunicipalityOptions): Promise<Municipality | null> {
        return options.id ? await this._service.getById(options.id, this.token) : null;
    }

    public async delete(options: MunicipalityOptions): Promise<void> {
        if (options.id) await this._service.delete(options.id, this.token);
    }

    public async update(options: MunicipalityOptions): Promise<Municipality | Municipality[] | null> {
        return options.item?.id
            ? await this._service.update(options.item.id, options.item, this.token)
            : null;
    }

    public async add(options: MunicipalityOptions): Promise<Municipality | Municipality[] | null> {
        return options.item ? await this._service.add(options.item, this.token) : null;
    }

    public async import(options: MunicipalityOptions): Promise<any> {
        if (options.file) return await this._service.import(this.token, options.file);
        return null;
    }

    public async export(options: MunicipalityOptions): Promise<any> {
        return await this._service.export(this.token, options.filter);
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult | null> {
        return await this._service.validateName(name, this.token, id, "");
    }
}
